import { CurrencyCode } from '../../context/currency';
import { MeasureUnitCode } from './MeasureUnitCode';

export class MeasureUnitInfo {
  constructor(
    public code: MeasureUnitCode,
    public isOriginalCurrency?: boolean,
    public currencyCode?: CurrencyCode
  ) {}
}
